<template>
<div class="rating-question">
  <div>
    <img v-if="node.question.image !== null" :src="node.question.image" class="question-image" />
    <p v-if="node.prompt !== null">{{node.prompt}}</p>
    <div v-html="node.question.instructions"></div>
    <div class="slider-widget">
      <h1>{{ value }}</h1>
      <v-slider
        v-model="value"
        class="rating-slider"
        :thumb-size="40"
        vertical
        style="width:40px;flex: 0 0 auto;"
        :min="node.question.min_value"
        :max="node.question.max_value">
      </v-slider>
    </div>
  </div>
  <div class="buttons">
    <v-btn
      class="submit-button"
      :disabled="!isValidSelection()"
      color="primary"
      @click="onAnswerQuestion">
      {{ submitButton }}
    </v-btn>
    <v-btn
      v-if="node.skippable"
      class="submit-button"
      color="secondary"
      @click="onSkipQuestion">
      {{ skipButton }}
    </v-btn>
  </div>
</div>
</template>

<script>
export default {
  name: 'RatingQuestion',
  data() {
    return {
      value: null,
    };
  },
  methods: {
    isValidSelection() {
      return this.value !== null;
    },
    onAnswerQuestion() {
      this.$emit('answer', { node: this.node, value: this.value });
      this.value = null;
    },
    onSkipQuestion() {
      this.$emit('skip');
      this.value = null;
    },
  },
  props: {
    node: Object,
    submitButton: String,
    skipButton: String,
  },
};
</script>

<style lang="scss" scoped>
@import "../styles/_variables.scss";

.rating-question {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  min-height: 100%;
  padding: 1.5rem 1.5rem 1.5rem 1.5rem;

  .question-image {
    display: block;
    max-width: 340px;
    margin-left: auto;
    margin-right: auto;
    margin-bottom: 2rem;
  }

  .slider-widget {
    display: flex;
    width: 100%;
    flex-direction: row;
    align-items: center;
    justify-content: center;

    h1 {
      display: block;
      width: 60px;
    }
  }

  .buttons {
    display: flex;
    width: 100%;
    flex-direction: row-reverse;
    justify-content: space-between;
    align-self: center;
  }
}

@media (min-width: $breakpoint-tablet) {
  .rating-question {
    justify-content: flex-start;

    .buttons {
      margin-top: 3rem;
    }
  }
}
</style>
